module.exports = __webpack_public_path__ + "img/dead-grey-trunk-08.dc33502a.png";